export class CivilCaseExt {
  caseTitleText: string;
  caseCategoryText: string;
  caseTrackingId: string;
  caseDocketId: string;
  jurisdictionalGroundsCode: string;
  caseTypeText: string;
  dateTimeFiled: Date;
  courtName:string;
  amountInControversy: number;
  conditionallySealed: boolean;

  complaints: any[];

  conciergeId?: number;
}

